import { Link } from 'react-router-dom';
import { ExternalLink, Clock, AlertCircle, BarChart2 } from 'lucide-react';
import { Site } from '../../types';
import { formatDate } from '../../utils/formatting';

interface SiteCardProps {
  site: Site;
}

export function SiteCard({ site }: SiteCardProps) {
  const hasLastScan = site.lastScanAt && site.lastScanScore !== undefined;

  return (
    <Link
      to={`/sites/${site.siteId}`}
      className="card-hover block group"
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1 min-w-0">
          <h3 className="text-heading-3 font-semibold text-dark-text truncate mb-1">
            {site.name}
          </h3>
          <a
            href={site.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => e.stopPropagation()}
            className="text-body-sm text-gray-medium hover:text-coral flex items-center gap-1 truncate"
          >
            {site.url}
            <ExternalLink size={14} />
          </a>
        </div>

        {/* Score/Grade Badge */}
        {hasLastScan && site.lastScanGrade && (
          <div className={`grade-${site.lastScanGrade.toLowerCase()} flex-shrink-0 ml-4`}>
            {site.lastScanGrade}
          </div>
        )}
      </div>

      {/* Last Scan Info */}
      {hasLastScan ? (
        <div className="flex items-center gap-4 text-body-sm flex-wrap">
          <div className="flex items-center gap-1.5 text-gray-medium">
            <Clock size={14} />
            <span>{formatDate(site.lastScanAt!)}</span>
          </div>
{site.scanCount !== undefined && site.scanCount > 0 && (
            <div className="flex items-center gap-1.5 text-gray-medium">
              <BarChart2 size={14} />
              <span>{site.scanCount} scan{site.scanCount !== 1 ? 's' : ''}</span>
            </div>
          )}
        </div>
      ) : (
        <div className="flex items-center gap-1.5 text-body-sm text-gray-medium">
          <AlertCircle size={14} />
          <span>No scans yet</span>
        </div>
      )}

      {/* Description */}
      {site.description && (
        <p className="text-body-sm text-gray-medium mt-3 line-clamp-2">
          {site.description}
        </p>
      )}

      {/* Hover indicator */}
      <div className="mt-4 pt-4 border-t border-gray-light">
        <span className="text-body-sm text-coral font-medium group-hover:underline">
          View details →
        </span>
      </div>
    </Link>
  );
}
